var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPriority = function SvgPriority(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 32,
    viewBox: "0 0 22 36",
    fill: "#E7760D",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.04.002a1.061 1.061 0 0 0-.801.45L.776 18.066a1.085 1.085 0 0 0 .311 1.55c.168.103.36.157.557.157l5.333-1.032a.427.427 0 0 1 .497.517l-2.58 10.985a1.074 1.074 0 0 0 .552 1.26 1.06 1.06 0 0 0 1.328-.316l12.818-17.614a1.085 1.085 0 0 0-.303-1.546 1.062 1.062 0 0 0-.553-.162l-6.787 1.054a.427.427 0 0 1-.471-.557l3.663-11a1.088 1.088 0 0 0-.204-.966 1.069 1.069 0 0 0-.897-.394Z"
  })));
};

export default SvgPriority;